import { ActivatedRouteSnapshot, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { IBreadcrumb, stringFormat } from './../breadcrumb.shared';

export class BreadcrumbResolver {
	public resolve(
		route: ActivatedRouteSnapshot
	): Observable<IBreadcrumb[]> | Promise<IBreadcrumb[]> | IBreadcrumb[] {
		const data = route.routeConfig.data;
		const path = this.getFullPath(route);

		let text =
			typeof data.breadcrumbs === 'string'
				? data.breadcrumbs
				: data.breadcrumbs.text || data.text || path;
		text = stringFormat(text, route.data);

		const crumbs: IBreadcrumb[] = [
			{
				text,
				path
			}
		];

		return of(crumbs);
	}

	public getFullPath(route: ActivatedRouteSnapshot): string {
		const relativePath = (segments: UrlSegment[]) =>
			segments.reduce((a, v) => (a += '/' + v.path), '');
		const fullPath = (routes: ActivatedRouteSnapshot[]) =>
			routes.reduce((a, v) => (a += relativePath(v.url)), '');

		return fullPath(route.pathFromRoot);
	}
}
